import { render, staticRenderFns } from "./NewLogoWaybillEntry.vue?vue&type=template&id=5bfd51c2&scoped=true&"
import script from "./NewLogoWaybillEntry.vue?vue&type=script&lang=js&"
export * from "./NewLogoWaybillEntry.vue?vue&type=script&lang=js&"
import style0 from "./NewLogoWaybillEntry.vue?vue&type=style&index=0&id=5bfd51c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfd51c2",
  null
  
)

export default component.exports